export const OAUTH_REDIRECT_KEY = 'magistral.oauth.redirect';
export const OAUTH_AUTO_REDIRECT = '__AUTO__';
export const TERMS_VERSION = '2025-11-28';
